import React, { InputHTMLAttributes } from "react";
import { Filter, X } from "lucide-react";
import useLang from "@/hooks/useLang";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { useSearchContext } from "@/contexts/SearchContext";

const InputSearch = ({ ...props }: InputHTMLAttributes<HTMLInputElement>) => {
  const { getText } = useLang();
  const isMobileXs = useMediaQuery("(max-width: 350px)");
  const { openFilter, setOpenFilter } = useSearchContext();

  return (
    <div className="relative w-full">
      <input
        {...props}
        type="text"
        placeholder={getText({ id: "search_craftman_firstname_name_workshop" })}
        className={`${
          isMobileXs ? "text-sm" : "text-base"
        } w-full px-4 py-3 pr-12 text-gray-700 bg-white border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200`}
        style={{ fontSize: "16px" }}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
      />
      <button
        type="button"
        className="absolute right-3 top-1/2 transform -translate-y-1/2 p-1 rounded-lg hover:bg-gray-100 transition-colors duration-200"
        onClick={() => setOpenFilter(!openFilter)}
        aria-label={openFilter ? "Close filter" : "Open filter"}
      >
        {openFilter ? (
          <X className="text-primary" size={20} />
        ) : (
          <Filter className="text-primary" size={20} />
        )}
      </button>
    </div>
  );
};

export default InputSearch;